import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import './index.css';
import './diffsize.css';
import './techstackcolars.css'
import App from './App';
//router browserrouter wrapped arround the App component
ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root')
 );